"use strict";
import {loaderFactory} from 'Subschema';
import Bank from './Bank.jsx';
import BankLess from './Bank.less';
import BankProcessor from './BankProcessor';

const loader = loaderFactory();

loader.addType('Bank', Bank);
loader.addStyle('Bank', BankLess);
loader.addProcessor('BankProcessor', BankProcessor);

export default loader;


/** WEBPACK FOOTER **
 ** ./src/types/bank/index.js
 **/